const Activity = () => {
    return (
        <>
            <div className="col-md-12 col-lg-4 mb-4">
                <div className="card">
                    <div className="d-flex align-items-end row">
                        <div className="col-8">
                            <div className="card-body">
                                <h6 className="card-title mb-1 text-nowrap">Congratulations Katie!</h6>
                                <small className="d-block mb-3 text-nowrap">Best seller of the month</small>
                                <h5 className="card-title text-primary mb-1">$48.9k</h5>
                                <small className="d-block mb-4 pb-1 text-muted">78% of target</small>
                                <a href="javascript:;" className="btn btn-sm btn-primary">View sales</a>
                            </div>
                        </div>
                        <div className="col-4 pt-3 ps-0">
                            <img src="../../iusevolutione/assets/img/illustrations/prize-light.png" width={90} height={140} className="rounded-start" alt="View Sales" />
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-lg-8 mb-4">
                <div className="card">
                    <div className="card-body row g-4">
                        <div className="col-md-6 pe-md-4 card-separator">
                            <div className="card-title d-flex align-items-start justify-content-between">
                                <h5 className="mb-0">New Visitors</h5>
                                <small>Last Week</small>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="mt-auto">
                                    <h2 className="mb-2">23%</h2>
                                    <small className="text-danger text-nowrap fw-medium"><i className="bx bx-down-arrow-alt" /> -13.24%</small>
                                </div>
                                <div id="visitorsChart" />
                            </div>
                        </div>
                        <div className="col-md-6 ps-md-4">
                            <div className="card-title d-flex align-items-start justify-content-between">
                                <h5 className="mb-0">Activity</h5>
                                <small>Last Week</small>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="mt-auto">
                                    <h2 className="mb-2">82%</h2>
                                    <small className="text-success text-nowrap fw-medium"><i className="bx bx-up-arrow-alt" /> 24.8%</small>
                                </div>
                                <div id="activityChart" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default Activity;